module.exports = __webpack_public_path__ + "static/media/V2_11.b7da819d.png";